export function getScreenWidth() {
  var width = window.innerWidth > 0 ? window.innerWidth : screen.width
  return width
}

export function shouldMobileLayout() {
  if (getScreenWidth() <= 600) {
    return true
  }
  return false
}

export enum MobilePlatform {
  PLATFORM_WINDOWSPHONE,
  PLATFORM_ANDROID,
  PLATFORM_IOS,
  PLATFORM_UNKNOWN
}

export function getMobileOperatingSystem() {
  let userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return MobilePlatform.PLATFORM_WINDOWSPHONE
  }

  if (/android/i.test(userAgent)) {
    return MobilePlatform.PLATFORM_ANDROID
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return MobilePlatform.PLATFORM_IOS
  }

  return MobilePlatform.PLATFORM_UNKNOWN
}
